import MultiColPointDataTable from '@components/_shared/MultiColPointDataTable';
import UIBox from '@components/_shared/UIBox';
import useGetInternalWidgetConfig from '@hooks/api/queries/widgets/useGetInternalWidgetConfig';
import { useCurrentPowinEmsDeviceContext } from '@hooks/useCurrentPowinEmsDevice';
import { Grid2 } from '@mui/material';
import { WidgetTypePointList } from '@src/types/Widget';

function PowinControllerDetails() {
  const { currentPowinEmsDevice } = useCurrentPowinEmsDeviceContext();
  const {
    data: widgetConfig,
    isLoading,
    isError,
  } = useGetInternalWidgetConfig<WidgetTypePointList>(
    'powinControllerDetails',
    {
      sourceDeviceId: currentPowinEmsDevice?.engineeringId,
    },
    {
      enabled: !!currentPowinEmsDevice?.engineeringId,
      queryKeys: [
        'powinControllerDetails',
        currentPowinEmsDevice?.deviceId || '',
      ],
    },
  );

  return (
    <UIBox
      header={widgetConfig?.header}
      subheader={currentPowinEmsDevice?.name}
      isLoading={isLoading || (!isLoading && !widgetConfig && !isError)}
      isError={isError || (!isLoading && !widgetConfig)}
    >
      <Grid2 container justifyContent='space-evenly'>
        <MultiColPointDataTable
          dataPointsMatrix={widgetConfig?.dataPoints || []}
        />
      </Grid2>
    </UIBox>
  );
}

export default PowinControllerDetails;
